<script lang="ts">
    import { icons } from "../../config"
    import { tooltip } from "../../helper"
    import { bookmarks, login } from "../../store"
    import { _ } from "svelte-i18n"

    import Icon from "./Icon.svelte"

    export let label: string = "",
        operation: Operation | OperationOut | FollowUpOperation | FollowUpOperationOut,
        largeVersion = false,
        overdue: boolean = false,
        forceNotBookmarkedIcon: boolean = false

    let personNumber: number
    let isBookmarked: boolean
    $: if (!personNumber) {
        if ("attachedAccount" in operation) personNumber = operation.attachedAccount.ident.personNumber
        else personNumber = $login?.account?.ident?.personNumber
    }
    $: isBookmarked = !!$bookmarks?.[operation.collectionName]?.[personNumber]?.[operation.id]
</script>

<style lang="less">
    .wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        .not-own {
            opacity: 0.5;
            pointer-events: none;
            .bookmark-icon {
                width: 24px !important;
                height: 24px !important;
            }
        }
    }
</style>

{#if !!$login}
    {#key isBookmarked}
        <div
            class="wrapper"
            use:tooltip="{personNumber !== $login.account.ident.personNumber
                ? {
                      content: $_('bookmarks.icon.editOwnResubmissionsOnly'),
                  }
                : false}"
        >
            <span
                use:tooltip="{{
                    content: isBookmarked
                        ? $_('bookmarks.icon.removeFromWatchlist')
                        : $_('bookmarks.icon.addToWatchlist'),
                }}"
                class="bookmark-icon {largeVersion ? 'large' : ''} {personNumber !==
                $login?.account?.ident?.personNumber
                    ? 'not-own'
                    : ''}"
                style="width: 24px !important; height: 24px !important;"
            >
                <Icon
                    size="{largeVersion ? '1.2rem' : '24px'}"
                    path="{forceNotBookmarkedIcon
                        ? icons.bookmarkOff
                        : isBookmarked
                          ? overdue
                              ? icons.bookmarkOverdue
                              : icons.bookmarkOn
                          : icons.bookmarkOff}"
                />
                {#if label}
                    <span class="label">{label}</span>
                {/if}
            </span>
        </div>
    {/key}
{/if}
